import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { registerSW } from 'virtual:pwa-register'

// MapLibre CSS loaded ONCE at the app root so the AttributionControl + popups
// render correctly in Plan 02-02 (Research Anti-Patterns line 659).
import 'maplibre-gl/dist/maplibre-gl.css'

import './styles/reset.css'
import './styles/tokens.css'

import { App } from './App'
import { SignIn } from './routes/SignIn'
import { AuthCallback } from './routes/AuthCallback'

const router = createBrowserRouter([
  { path: '/', element: <App /> },
  { path: '/signin', element: <SignIn /> },
  { path: '/auth/callback', element: <AuthCallback /> },
])

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root missing from index.html')

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)

// Auto-update service worker on next navigation (UI-SPEC §PWA Shell line 612).
registerSW({ immediate: true })
